const NAMES: Record<string, string> = {
  AFR: "Afrikaans",
  AII: "Assyrian Neo-Aramaic",
  AMH: "Amharic",
  APC: "Levantine Arabic",
  AFB: "Gulf Arabic",
  ARB: "Arabic",
  ARC: "Aramaic",
  ARZ: "Egyptian Arabic",
  AZJ: "Azerbaijani",
  BAM: "Bambara",
  BEL: "Belarusian",
  BEN: "Bengali",
  BOD: "Tibetan",
  BRE: "Breton",
  BUL: "Bulgarian",
  CAT: "Catalan",
  CES: "Czech",
  CHR: "Cherokee",
  CKB: "Sorani Kurdish",
  CMN_CN: "Mandarin (China)",
  CMN_TW: "Mandarin (Taiwan)",
  CMN_US: "Mandarin (US)",
  CYM: "Welsh",
  DAN: "Danish",
  DEU: "German",
  DEU_AT: "German (Austria)",
  DEU_HE: "German (Hessian)",
  DSB: "Lower Sorbian",
  EKK: "Estonian",
  ELL: "Greek",
  ENG_GB: "English (UK)",
  ENG_US: "English (US)",
  EUS: "Basque",
  EWE: "Ewe",
  FIN: "Finnish",
  FRA: "French",
  GLA: "Scottish Gaelic",
  GLE: "Irish",
  HAK_SX: "Hakka (Sixian)",
  HAU: "Hausa",
  HAW: "Hawaiian",
  HEB: "Hebrew",
  HIN: "Hindi",
  HRV: "Croatian",
  HSB: "Upper Sorbian",
  HUN: "Hungarian",
  HYE: "Armenian",
  IBO: "Igbo",
  IND: "Indonesian",
  ISL: "Icelandic",
  ITA: "Italian",
  JPN: "Japanese",
  KAL: "Greenlandic",
  KAN: "Kannada",
  KAT: "Georgian",
  KAZ: "Kazakh",
  KHK: "Mongolian",
  KHM: "Khmer",
  KIN: "Kinyarwanda",
  KIR: "Kyrgyz",
  KOR: "Korean",
  KUR: "Kurdish",
  LAO: "Lao",
  LAT: "Latin",
  LAV: "Latvian",
  LIN: "Lingala",
  LIT: "Lithuanian",
  LTZ: "Luxembourgish",
  MAL: "Malayalam",
  MKD: "Macedonian",
  MLT: "Maltese",
  MNK: "Mandinka",
  MOS: "Mooré",
  MRI: "Māori",
  MYA: "Burmese",
  NAN: "Hokkien",
  NAV: "Navajo",
  NEP: "Nepali",
  NLD: "Dutch",
  NNO: "Norwegian Nynorsk",
  NOR: "Norwegian",
  PBT: "Pashto",
  PES: "Persian",
  POL: "Polish",
  POR_BR: "Portuguese (Brazil)",
  POR_PT: "Portuguese (Portugal)",
  ROH: "Romansh",
  RON: "Romanian",
  RUE: "Rusyn",
  RUS: "Russian",
  SAH: "Sakha",
  SLK: "Slovak",
  SLV: "Slovene",
  SME: "Northern Sámi",
  SMO: "Samoan",
  SPA_AR: "Spanish (Argentina)",
  SPA_ES: "Spanish (Spain)",
  SPA_MX: "Spanish (Mexico)",
  SPA_US: "Spanish (US)",
  SQI: "Albanian",
  SRP: "Serbian",
  SWE: "Swedish",
  SWH: "Swahili",
  TAM_IN: "Tamil",
  TAT: "Tatar",
  TEL: "Telugu",
  TGK: "Tajik",
  TGL: "Tagalog",
  THA: "Thai",
  TUR: "Turkish",
  TWI: "Twi",
  UIG: "Uyghur",
  UKR: "Ukrainian",
  URD: "Urdu",
  UZN: "Uzbek",
  VIE: "Vietnamese",
  VIE_HN: "Vietnamese (Hanoi)",
  VIE_SG: "Vietnamese (Saigon)",
  WOL: "Wolof",
  XHO: "Xhosa",
  YOR: "Yoruba",
  YUE_HK: "Cantonese",
  ZSM: "Malay",
  ZUL: "Zulu",
};

export function getLanguageName(code: string): string {
  return NAMES[code] ?? code;
}
